import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card"
}
const _hoisted_2 = { class: "card-header align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Student Details", -1)
const _hoisted_4 = { class: "position-absolute top-0 end-0 mt-2 me-3 pt-2 pe-1 z-index-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "card-body bg-light" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-falcon-default btn-sm",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              title: "",
              "data-bs-original-title": "Back to Group",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToClassGroupList && _ctx.backToClassGroupList(...args)))
            }, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            id: "classgroup-create-form",
            onSubmit: _ctx.processForm,
            initialValues: _ctx.student,
            "validation-schema": _ctx.schema,
            onKeypress: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Input, {
                  id: "classgroup-create-group-name",
                  label: "Name",
                  name: "name",
                  placeholder: "Name",
                  value: _ctx.student.name,
                  error: errors.name,
                  disabled: ""
                }, null, 8, ["value", "error"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Input, {
                  id: "classgroup-create-group-name",
                  label: "Email",
                  name: "email",
                  placeholder: "Email",
                  value: _ctx.student.email,
                  error: errors.email,
                  disabled: ""
                }, null, 8, ["value", "error"])
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "btn btn-primary d-block w-100 mt-3",
                  type: "submit",
                  name: "submit",
                  textContent: _toDisplayString('Save'),
                  disabled: ""
                }, null, 8, _hoisted_12)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "initialValues", "validation-schema"])
        ])
      ]))
}